import { render, staticRenderFns } from "./MenuInspiration.vue?vue&type=template&id=4c77ff38&"
import script from "./MenuInspiration.vue?vue&type=script&lang=js&"
export * from "./MenuInspiration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports